package com.eladfinish.bible.contest.features.copyOptions.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.features.copyOptions.CopyOptionsAction
import com.eladfinish.bible.contest.features.copyOptions.CopyOptionsEffect
import com.eladfinish.bible.contest.features.copyOptions.CopyOptionsStore
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.components.dialogs.DialogNegativeButton
import com.eladfinish.bible.contest.ui.components.dialogs.DialogPositiveButton
import kotlinx.coroutines.flow.collectLatest
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun CopyOptionsDialog(
    store: CopyOptionsStore = koinViewModel(),
    title: String,
    onDismiss: () -> Unit,
    onSaveFile: ((String) -> Unit)? = null,
) {
    val state = store.observeState().collectAsState().value

    LaunchedEffect(store) {
        store.observeSideEffect().collectLatest { effect ->
            when (effect) {
                CopyOptionsEffect.CloseDialog -> {
                    onDismiss()
                }

                is CopyOptionsEffect.SaveFile -> {
                    onSaveFile?.invoke(effect.content)
                    onDismiss()
                }
            }
        }
    }

    BasicDialogWithTitle(
        title = title,
        onDismiss = onDismiss,
        content = {
            CopyOptionsContent(
                state = state,
                onAction = store::dispatch,
                modifier = Modifier.weight(1f),
            )

            Spacer(modifier = Modifier.height(16.dp))

            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.CenterHorizontally),
                modifier = Modifier.fillMaxWidth(),
            ) {
                DialogPositiveButton(
                    onClick = {
                        store.dispatch(
                            CopyOptionsAction.ConfirmCopyClicked,
                        )
                    },
                )
                DialogNegativeButton(
                    onClick = onDismiss,
                )
            }
        },
    )
}
